// =====================================================
// WeLearn Pro Player - Loader module
// =====================================================

import Debug from './util/debugHelper.js';
import Caption from './caption';
import Bootstrap4Helper from './util/bootstrapHelper'
import Exception from './exception';
import HideYt from './util/hide-yt'

export default class Loader {
    constructor(player) {
        this.player = player;
        this.debug = new Debug(this.player.options.debug);
        this.exception = new Exception(this.player);
        this.HideYt = HideYt;

        this.caption = new Caption(this.player);
    }

    /**
     * Initialize WeLearn Pro Player.
     */
    initVideo() {
        if (this.player.options.embedVideo === true) {
            this.loadEmbedVideo(this.player.options.video);
        } else {
            this.loadVideoSources(this.player.options.video, this.player.options.thumbnail);
        }

        $.i18n().load({
            'en-US': '/Scripts/welearnpro-player/i18n/en.json',
            'th-TH': '/Scripts/welearnpro-player/i18n/th.json'
        });

        /*if (this.player.options.previewMode === false)
        {*/
        this.loadCaptions();
        //}
    }

    /**
     * Load video from the player option
     * @param url - Video URL
     * @param thumbnail - Video thumbnail
     */
    loadVideoSources(url = this.player.options.video, thumbnail = this.player.options.thumbnail) {
        let videoPlayer = $(this.player.element);

        videoPlayer.attr("src", url);
        videoPlayer.attr("poster", thumbnail);

        this.debug.log('Video source loaded');
    }

    loadEmbedVideo(url = this.player.options.video) {
        // Convert video element into youtube div
        if (this.player.options.embedVideo) {
            this.convertVideoToEmbedded();
        }
        this.debug.log('Embed video source loaded');
    }

    convertVideoToEmbedded() {
        let videoPlayer = $(this.player.element);
        let videoPlayerElementName = videoPlayer.get(0).id;

        videoPlayer.replaceWith(`<div class="plyr__video-embed" id='${videoPlayerElementName}'>`);

        let origin = window.location.origin;
        let source = `${this.player.options.video}?origin=${origin}&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`;

        $('#' + videoPlayerElementName).append(`<iframe
			src="${source}"
			allowfullscreen
			allowtransparency
			allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>`);
    }

    /**
     * Load user's watch progress data.
     */
    loadVideoData(userId) {
        let self = this;

        let videoId = self.player.progressData.videoId;

        this.debug.log({ userId: userId, videoId: videoId });

        if ((userId) && (videoId)) {
            self.loadWatchedProgress();
            self.loadQuizs();
            /*self.loadNotes();
            self.loadSlides();*/
        } else {
            if (self.player.options.progress.load.alert === true) {
                Bootstrap4Helper.invokeAlert(self.player.options.progress.load.alertMessage, 5000, '.wlpVideo__progress-bar');
            }
        }

        /*$.ajax({
            url: self.player.options.progress.load.url,
            data: {
                userId : userId,
                videoId : this.player.progressData.videoId
            },
            type: 'post',
            success: function(result)
            {
                self.loadWatchedProgress();
                self.loadQuizs();
                self.loadNotes();
                self.loadSlides();
            },
            error: function(result)
            {
                if (self.player.options.progress.load.alert === true)
                {
                    Bootstrap4Helper.invokeAlert(self.player.options.progress.load.alertMessage, 5000, '.wlpVideo__progress-bar');
                }
            }
        });*/
    }

    loadWatchedProgress() {
        if (this.player.progressData['timestamp']) {
            if (self.options.debug === true) {
                console.log('DEBUG: Video data object: ');
                console.log(this.player.progressData['timestamp']);
            }

            for (let i = 0; i < Object.values(this.player.progressData['timestamp']).length; i++) {
                $('.tick[data-timestamp=' + this.player.progressData['timestamp'][i] + ']').addClass('watched').addClass('saved');
            }
        }
    }

    loadQuizs() {
        for (let i = 0; i < Object.values(this.player.videoComponent['quiz']).length; i++) {
            $('.tick[data-timestamp=' + this.player.videoComponent['quiz'][i]['time'] + ']').attr("data-quiz", this.player.videoComponent['quiz'][i]['quizId']);
            $('.tick[data-timestamp=' + this.player.videoComponent['quiz'][i]['time'] + ']').attr("data-csm", this.player.videoComponent['quiz'][i]['quizCourseSectionModuleId']);
            $('.tick[data-timestamp=' + this.player.videoComponent['quiz'][i]['time'] + ']').addClass('test');
        }
    }

    loadNotes() {
        for (let i = 0; i < Object.values(this.player.progressData['note']).length; i++) {
            $('.tick[data-note=' + this.player.progressData['note'][i]['time'] + ']').addClass('note');
        }
    }

    loadSlides() {
        for (let i = 0; i < Object.values(this.player.progressData['slide']).length; i++) {
            $('.tick[data-slide=' + this.player.progressData['slide']['page'][i]['time'] + ']').addClass('slide');
        }
    }

    loadCaptions() {
        let captions = this.player.videoComponent.caption;
        if (captions && captions.length) {
            // Add captions (If exists);
            for (let i = 0; i < captions.length; i++) {
                this.caption.addCaption(captions[i]["label"], captions[i]["srclang"], captions[i]["src"], captions[i]["default"]);
            }
        }
    }

    parseProgressBar() {
        // Parse slide data from slide object
        for (let i = 0; i < this.player.progressData.slide.pages.length; i++) {
            $(`span.tick[data-timestamp='${this.player.progressData.slide.pages[i].time}']`).attr('data-page', this.player.progressData.slide.pages[i].page);
        }

        // Parse note data from note object
        for (let i = 0; i < this.player.progressData.note.length; i++) {
            $(`span.tick[data-timestamp='${this.player.progressData.note[i].time}']`).attr('data-note', this.player.progressData.note[i].noteId);
        }

        // Parse test data from test object
        for (let i = 0; i < this.player.progressData.note.length; i++) {
            $(`span.tick[data-timestamp='${this.player.progressData.test[i].time}']`).attr('data-test', this.player.progressData.test[i].testId);
        }
    }
}